import { render } from "./QuickAddToCartPopover.vue?vue&type=template&id=12420ca8&scoped=true"
const script = {}

import "./QuickAddToCartPopover.vue?vue&type=style&index=0&id=12420ca8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12420ca8"]])

export default __exports__